import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const DiagramIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7.5 2.857a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1zm3.25 3h1.5v1.5A2.25 2.25 0 0 1 10 9.607H7a.75.75 0 0 0-.75.75v1.5h-1.5v-1.5A2.25 2.25 0 0 1 7 8.107h3a.75.75 0 0 0 .75-.75zm-8.25 7a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z"
		></path>
	</svg>
))
